import { useEffect, useState, useRef } from "react";
import { HashRouter, Routes, Route } from "react-router-dom";

import "./App.css";

// components
import NavBar from "./components/NavBar";
import Home from "./Home";
import Information from "./Information";
import Documents from "./Documents";
import CaveTroll from "./resources/images/cave-troll.gif";

function App() {
  const [loading, setLoading] = useState(true);
  const loadingGifRef = useRef();
  const scrollableAreaRef = useRef();

  async function loadApp() {
    loadingGifRef.current.src = CaveTroll;

    scrollableAreaRef.current.style.height = "100vh";
    scrollableAreaRef.current.style.overflow = "hidden";

    // scroll to top

    console.log(window.scrollY);

    // disable loading screen for dev
    let delay = window.location.hostname === "localhost" ? 2500 : 2500;

    await setTimeout(() => {
      setLoading(false);
      scrollableAreaRef.current.style.height = "auto";
      scrollableAreaRef.current.style.overflow = "visible";
    }, delay);
  }

  useEffect(() => {
    console.clear();
    loadApp();
  }, []);

  return (
    <div ref={scrollableAreaRef} className="App">
      <div className={"main-container " + (loading ? "" : "loaded")}>
        <HashRouter>
          <NavBar />
          <div className="page-container">
            <Routes>
              <Route path="/" element={<Home />}></Route>
              <Route path="/information" element={<Information />}></Route>
              <Route path="/documents-videos" element={<Documents />}></Route>
            </Routes>
            <div className="footer">
              <span>
                Copyright © 2022-{new Date().getFullYear()} ZMotion Team. All
                rights reserved.
                <br /> This project was completed as part of{" "}
                <a
                  href="https://www.ceias.nau.edu/cs/CS_Capstone/CS476.html"
                  target="_blank"
                  rel="noreferrer">
                  Northern Arizona University's Computer Science Capstone
                  Program
                </a>
                .
              </span>
              <span style={{ display: "block", marginTop: "20px" }}>
                <i>~ "Creating the experience of dreams" ~</i>
              </span>
            </div>
          </div>
        </HashRouter>
      </div>
      <div className={"loading-screen " + (loading ? "" : "hidden")}>
        <img alt="Loading Cave Troll" ref={loadingGifRef} src={null} />
      </div>
    </div>
  );
}

export default App;
